"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationsLanguage = exports.mergeTranslationsIn = exports.parsePoFile = void 0;
const _ = __importStar(require("lodash"));
const gettextparser = __importStar(require("gettext-parser"));
function parsePoFile(content) {
    return gettextparser.po.parse(content);
}
exports.parsePoFile = parsePoFile;
function mergeTranslationsIn(target, ...sources) {
    function setIn(msgctxt, msgId, translation) {
        _.set(target, [msgctxt, msgId], translation);
    }
    for (let source of sources) {
        for (let [msgctxt, messages] of Object.entries(source.translations)) {
            for (let [msgId, translation] of Object.entries(messages)) {
                setIn(msgctxt, msgId, translation);
            }
        }
    }
    return target;
}
exports.mergeTranslationsIn = mergeTranslationsIn;
function getTranslationsLanguage(trans) {
    let result = trans.headers['Language'];
    if (!result) {
        throw new Error('Missing language header in translation.');
    }
    return result.split('_')[0];
}
exports.getTranslationsLanguage = getTranslationsLanguage;
//# sourceMappingURL=po.js.map